import React from "react";

export default function AppLayout({ children }) {
  return (
    <div id="wrap">
      <main id="main" class="main">
        {children}
      </main>
    </div>
  );
}
